module.exports = __webpack_public_path__ + "static/card-back-1-ec2c4d7831448d8562cd47c05126a313.png";